import { CmsHtml } from '@packages/modules/src/CmsHtml/CmsHtml.client';
import { ComponentTypes } from '../../../interfaces/components';
import { CategoryTeaser } from '../CategoryTeaser/CategoryTeaser.client';
import { CmsAccordion } from '../CmsAccordion/CmsAccordion.client';
import { CmsCarousel } from '../CmsCarousel/CmsCarousel.client';
import { CmsDynamicYield } from '../CmsDynamicYield/CmsDynamicYield';
import { CmsEpsRecommendation } from '../CmsEpsRecommendation/CmsEpsRecommendation';
import { CmsGroup } from '../CmsGroup/CmsGroup';
import { CmsImage } from '../CmsImage/CmsImage.client';
import { CmsInstallmentCalculator } from '../CmsInstallmentCalculator/CmsInstallmentCalculator.client';
import { CmsRecommendation } from '../CmsRecommendation/CmsRecommendation';
import { EmptySlot } from '../EmptySlot/EmptySlot';
import { ExternalScript } from '../ExternalScript/ExternalScript.client';
import { FlagshipTeaser } from '../FlagshipTeaser/FlagshipTeaser.client';
import { BlockBadges } from '../Footer/BlockBadges/BlockBadges';
import { BlockImage } from '../Footer/BlockImage/BlockImage';
import { BlockList } from '../Footer/BlockList/BlockList';
import { BlockText } from '../Footer/BlockText/BlockText';
import { ImageGroup } from '../Footer/ImageGroup/ImageGroup.client';
import {
  LegacyNewsletter,
  NewsletterSubscribe,
  NewsletterUnsubscribe,
} from '../Forms/Newsletter/Newsletter.client';
import { CmsHeadline } from '../Headline/Headline.client';
import { HermesShopFinder } from '../HermesShopFinder/HermesShopFinder';
import { LinkBox } from '../LinkBox/LinkBox.client';
import { LinkByButton } from '../LinkByButton/LinkByButton.client';
import { LinkByText } from '../LinkByText/LinkByText.client';
import { ModalByButton } from '../ModalByButton/ModalByButton.client';
import { OverlayCircle } from '../OverlayCircle/OverlayCircle.client';
import { OverlayRectangle } from '../OverlayRectangle/OverlayRectangle.client';
import { Placeholder } from '../Placeholder/Placeholder.client';
import { RelatedContent } from '../RelatedContent/RelatedContent.client';
import { SectionSeperator } from '../SectionSeperator/SectionSeperator';
import { Video } from '../Video/Video.client';
import { Voucher } from '../Voucher/Voucher.client';
import { registerComponents } from './componentRegistry';

/**
 * Registers a set of components using the previously defined registerComponent function.
 * don't forget to register the dynamic components if <ComponentRecognizer /> is in use. Example:
 * ```
 *    import { registerFlexibleComponents } from '@packages/cms-components/src/components/ComponentRecognizer/registerFlexibleComponents';
 *    registerFlexibleComponents();
 * ```
 */
export const registerFlexibleComponents = (): void => {
  registerComponents({
    [ComponentTypes.Html]: CmsHtml,
    [ComponentTypes.HtmlParagraph]: CmsHtml,
    [ComponentTypes.Placeholder]: Placeholder,
    [ComponentTypes.Group]: CmsGroup,
    [ComponentTypes.GroupLocalizable]: CmsGroup,
    [ComponentTypes.GroupApp]: CmsGroup,
    [ComponentTypes.SvgFile]: CmsImage,
    [ComponentTypes.ImageSimple]: CmsImage,
    [ComponentTypes.ImageFooter]: CmsImage,
    [ComponentTypes.Headline]: CmsHeadline,
    [ComponentTypes.Accordion]: CmsAccordion,
    [ComponentTypes.AccordionLocalizable]: CmsAccordion,
    [ComponentTypes.LinkByButton]: LinkByButton,
    [ComponentTypes.FlagshipTeaser]: FlagshipTeaser,
    [ComponentTypes.LinkByText]: LinkByText,
    [ComponentTypes.LinkBox]: LinkBox,
    [ComponentTypes.DynamicYield]: CmsDynamicYield,
    [ComponentTypes.RecoPrudsys]: CmsRecommendation,
    [ComponentTypes.RecoEps]: CmsEpsRecommendation,
    [ComponentTypes.RelatedContent]: RelatedContent,
    [ComponentTypes.SectionSeperator]: SectionSeperator,
    [ComponentTypes.OverlayCircle]: OverlayCircle,
    [ComponentTypes.OverlayRectangle]: OverlayRectangle,
    [ComponentTypes.InstallmentCalculator]: CmsInstallmentCalculator,
    [ComponentTypes.ButtonModal]: ModalByButton,
    [ComponentTypes.ExternalScript]: ExternalScript,
    [ComponentTypes.ExternalScriptHappyContest]: ExternalScript,
    [ComponentTypes.ExternalScriptLoadbee]: ExternalScript,
    [ComponentTypes.Newsletter]: LegacyNewsletter,
    [ComponentTypes.NewsletterSubscription]: NewsletterSubscribe,
    [ComponentTypes.NewsletterUnsubscribe]: NewsletterUnsubscribe,
    [ComponentTypes.VoucherList]: Voucher,
    [ComponentTypes.Video]: Video,
    [ComponentTypes.Carousel]: CmsCarousel,
    [ComponentTypes.BlockText]: BlockText,
    [ComponentTypes.BlockList]: BlockList,
    [ComponentTypes.BlockImage]: BlockImage,
    [ComponentTypes.BlockBadges]: BlockBadges,
    [ComponentTypes.FooterGroupImage]: ImageGroup,
    [ComponentTypes.CategoryTeaser]: CategoryTeaser,
    [ComponentTypes.HermesShopFinder]: HermesShopFinder,
    [ComponentTypes.EmptySlot]: EmptySlot,
  });
};
